export const isEmptyObject = (value) =>
  value.constructor === Object && Object.keys(value).length === 0;

export const WanConnectionStatusMapping = {
  disabled: 'Disabled',
  offline: 'Offline',
  no_internet: 'No Internet',
  online: 'Online',
};

export const WanConnections = Object.keys(WanConnectionStatusMapping);

export const pluralize = (count, noun, suffix = 's') =>
  `${noun}${count !== 1 ? suffix : ''}`;

export const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes || +bytes < 1) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};
